const en = {
  language: {
    zh: '中文',
    en: 'English',
    id: 'Indonesia',
    th: 'ภาษาไทย'
  },
  dialog: {
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  error: {
    tips_1: 'There was a slight discrepancy in the service',
    tips_2: "It seems like we can't find the resources anymore",
    tips_3: 'Operation failed, please contact the merchant',
  },
  bindings: {
    deviceBinding: 'Device binding',
    tips: 'Tips',
    tipsContent: 'Please enter the device number to bind the device. You can check data usage at any time',
    device: 'Device Number',
    deviceTips: 'Please enter the device number',
    searchHistory: 'Search history',
    searches: 'Searches',
    binding: 'Binding',
    imeiTips: 'Please enter the device number'
  },
  xinXunIndex: {
    deviceManagement: 'Device management',
    onlineDevice: 'Online device',
    currentNetwork: 'Current network',
    signalStrength: 'Signal strength',
    online: 'Online',
    offline: 'Offline',
    switchingDevices: 'Switching devices',
    daysRemaining: 'Days remaining',
    usedData: 'Used data',
    toady: "Today's usage",
    total: 'Total',
    rechargeAndPay: 'Recharge and pay',
    myPackage: 'My Package',
    customerService: 'Customer service',
    change: 'Change name and password',
    hotspotName: 'Hotspot name',
    password: 'WIFI password',
    saveChanges: 'Save changes',
    status: 'Status',
    language: 'Language',
    wifiName: 'Name cannot be empty',
    wifiPassword: 'Password cannot be empty',
    wifiTips: 'Kind reminder: After successful modification, please restart the device. Remote modification of account and password requires a waiting time of 3-5 minutes. Please be patient.',
  },
  usage: {
    myPackage: 'My Package',
    currentPackage: 'Current package',
    packageRenewalHistory: 'Package renewal history',
    rechargeAndPay: 'Recharge and pay',
    effectiveDate: 'Effective date',
    expirationDate: 'Expiration date',
    useData: 'Data usage of current package',
    orderNumber: 'Order number',
    received: 'Received',
    processing: 'Processing',
    unknown: 'Unknown'
  },
  planList: {
    home: 'Home page',
    packageList: 'Package list',
    monthlyAverage: 'Monthly average',
    validityPeriod: 'Validity period',
    days: 'Days',
    unlimited: 'Unlimited',
    longTerm: 'long-term effective',
    tips_1: "This device currently does not have a recharge package. Please contact the store's customer service",
    tips_2: 'This device currently does not have a recharge package. Please contact customer service for timely processing',
    newUserOffer: 'New User Offer'
  },
  packageDetails: {
    packageDetails: 'Package details',
    data: 'Data',
    packageDescription: 'Package description',
    rechargeNow: 'Recharge now'
  },
  recharge: {
    payNow: 'Pay now',
    // unit: '$',
    unit: '¥',
    paymentMethod: 'Payment method',
    onlinePayment: 'Online payment',
    alipayPayment: 'Payment by Alipay',
    weChatPayment: 'Payment by Wechatpay',
    effectiveDate: 'Effective date',
    activateNow: 'Activate now',
    selectDate: 'Select date',
    createOrderTip: 'Order is being created, please wait a moment'
  },
  qrCode: {
    tips_1: 'You need to grant camera access permission',
    tips_2: 'There is no camera on this device',
    tips_3: 'Camera occupied',
    tips_4: 'Inappropriate installation of camera',
    tips_5: 'This browser does not support streaming API',
    tips_6: 'Required security context (HTTPS, local host)',
  },
  toast: {
    loading: 'Loading... ..'
  }
}

export default en